import { IRoute } from "../app";
import UserGroupNew from "../platform/pages/user-group/user-group";
import UserGroupList from "../platform/pages/user-group-list/user-group-list";
import Actions from "./pages/actions/actions";
import AggregatorAlertCase from "./pages/aggregator-alertcase/aggregator-alertcase";
import AlertCase from "./pages/alertcase/alertcase";
import AlertCaseNew from "./pages/alertcase-new/alertcase-new";
import AlertCasesList from "./pages/alertcases/alertcases";
import DeletedAlertcases from "./pages/deleted-alertcases/deleted-alertcases";
import DocumentSearch from "./pages/document-search/document-search";
import DomainProcessTypes from "./pages/domain-process-types/domain-process-types";
import EntityCapture from "./pages/entity-capture/entity-capture";
import EntityCapturesList from "./pages/entity-captures/entity-captures";
import EventCapture from "./pages/event-capture/event-capture";
import EventCapturesList from "./pages/event-captures/event-captures";
import ManagerConfig from "./pages/manager-config/manager-config";
import Screen from "./pages/screen/screen";
import ScreensList from "./pages/screen-list/screen-list";
import AdvancedSearch from "./pages/advanced-search/advanced-search";

const ManagerRoutes = (hasSystemAdminRole: boolean, hasTenantAdminRole: boolean, hasWriteRole: boolean, hasReadRole: boolean) => {
  const routes: IRoute[] = [
    {
      route: {path: "/user-groups", element: <UserGroupList />},
      allowed: hasSystemAdminRole || hasTenantAdminRole
    },
    {
      route: {path: "/user-groups/new", element: <UserGroupNew />},
      allowed: hasSystemAdminRole || hasTenantAdminRole
    },
    {
      route: {path: "/user-groups/:id", element: <UserGroupNew /> }, 
      allowed: hasSystemAdminRole || hasTenantAdminRole
    },
    {
      route: {path: "/manager/alertcases", element: <AlertCasesList />},
      allowed: hasWriteRole || hasReadRole
    },
    {
      route: {path: "/manager/alertcases/new", element: <AlertCaseNew />},
      allowed: hasWriteRole || hasReadRole
    },
    {
      route: {path: "/manager/alertcases/:id", element: <AlertCase />},
      allowed: hasWriteRole || hasReadRole
    },
    {
      route: {path: "/manager/screens", element: <ScreensList />},
      allowed: hasTenantAdminRole
    },
    {
      route: {path: "/manager/screens/new", element: <Screen />},
      allowed: hasTenantAdminRole
    },
    {
      route: {path: "/manager/screens/:id", element: <Screen />},
      allowed: hasTenantAdminRole
    },
    {
      route: { path: "/manager/actions", element: <Actions />},
      allowed: hasTenantAdminRole
    },
    {
      route: { path: "/manager/event_capture_screens", element: <EventCapturesList />},
      allowed: hasTenantAdminRole
    },
    {
      route: { path: "/manager/event_capture_screens/new", element: <EventCapture />},
      allowed: hasTenantAdminRole
    },
    {
      route: { path: "/manager/event_capture_screens/:id", element: <EventCapture />},
      allowed: hasTenantAdminRole
    },
    {
      route: { path: "/manager/entity_capture_screens", element: <EntityCapturesList />},
      allowed: hasTenantAdminRole
    },
    {
      route: { path: "/manager/entity_capture_screens/new", element: <EntityCapture />},
      allowed: hasTenantAdminRole
    },
    {
      route: { path: "/manager/entity_capture_screens/:id", element: <EntityCapture />},
      allowed: hasTenantAdminRole
    },
    {
      route: { path: "/manager/domain-process-types", element: <DomainProcessTypes />},
      allowed: hasTenantAdminRole
    },
    {
      route: { path: "/manager/actions", element: <Actions />},
      allowed: hasTenantAdminRole
    },
    {
      route: { path: "/manager/configuration", element: <ManagerConfig />},
      allowed: hasTenantAdminRole
    },
    {
      route: { path: "/manager/aggregator_alertcases/new", element: <AggregatorAlertCase />},
      allowed: hasWriteRole || hasReadRole
    },
    {
      route: { path: "/manager/aggregator_alertcases/:id", element: <AggregatorAlertCase />},
      allowed: hasWriteRole || hasReadRole
    },
    {
      route: { path: "/manager/document-search", element: <DocumentSearch />},
      allowed: hasWriteRole || hasReadRole
    },
    {
      route: { path: "/manager/advanced-search", element: <AdvancedSearch />},
      allowed: hasWriteRole || hasReadRole
    },
    {
      route: { path: "/manager/deleted-alertcases", element: <DeletedAlertcases />},
      allowed: hasTenantAdminRole
    }
  ];

  return routes.filter((route) => route.allowed).map((route) => route.route);
};

export default ManagerRoutes;
